
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import DateTimePicker from "@/components/DateTimePicker/index.vue";
import { handleFill, timeFormat } from "@/utils/util";
import dayjs from 'dayjs'

const minDate = new Date(dayjs().subtract(10, 'year').format('YYYY-MM-DD'))
const maxDate = new Date(dayjs().add(10, 'year').format('YYYY-MM-DD'))
@Component({
  components: { DateTimePicker },
})
export class SearchPopup extends Vue {
  @Prop({ default: true }) showBtnWrap: boolean // 是否显示按钮
  @Prop({ default: () => { } }) defaultValue: any // 把confirm传出去的值传回来回显数据
  @Prop({ default: require("@/assets/images/shouyin/statement/calendar.png") })
  btnSrc: string; // 按钮图标 require('@/assets/images/shouyin/statement/calendar.png')
  @Prop({ default: "时间范围选择" }) popupTitle: string; // popup标题
  @Prop({ default: "时间范围" }) customDateText: string; // 自定义日期文本
  /** 弹层挂载节点，接龙页等无 #content 时需传 body，避免被底部栏盖住 */
  @Prop({ default: "#content" }) getContainer!: string | (() => Element);
  @Prop({ default: minDate }) startMinDate: Date;
  @Prop({ default: maxDate }) startMaxDate: Date;
  @Prop({ default: 0 }) startMinHour: number;
  @Prop({ default: 23 }) startMaxHour: number;
  @Prop({ default: minDate}) endMinDate: Date;
  @Prop({ default: maxDate }) endMaxDate: Date;
  @Prop({ default: 0 }) endMinHour: number;
  @Prop({ default: 23 }) endMaxHour: number;
  startDefaultValue = {
    datetimeVal1: '',
    datetimeVal2: '00:00'
  }
  startPlaceholder1 = '开始日期'
  startPlaceholder2 = '开始时间'
  endDefaultValue = {
    datetimeVal1: '',
    datetimeVal2: '23:59'
  }
  endPlaceholder1 = '截止日期'
  endPlaceholder2 = '截止时间'
  show = false;
  // 0初始状态 1开始时间 2截止时间
  selectType = 0

  @Watch("show")
  onShowChange (newVal) {
    if (newVal) {
      if (this.defaultValue) {
        const { value, startVal1, startVal2, startDatetimeValueType = 0, showStartDatetimePicker = false, endVal1, endVal2, endDatetimeValueType = 0, showEndDatetimePicker = false } = this.defaultValue
        this.selectType = value
        // 初始化日期/时间选择组件
        this.executeDateTimePickerInit('dateTimePickerRef1', {
          valueType: startDatetimeValueType,
          showDatetimePicker: showStartDatetimePicker,
          datetimeVal1: startVal1,
          datetimeVal2: startVal2
        });
        this.executeDateTimePickerInit('dateTimePickerRef2', {
          valueType: endDatetimeValueType,
          showDatetimePicker: showEndDatetimePicker,
          datetimeVal1: endVal1,
          datetimeVal2: endVal2
        });
      }
    } else {
      // 重置日期/时间选择组件
      (this.$refs.dateTimePickerRef1 as any).resetData();
      (this.$refs.dateTimePickerRef2 as any).resetData();
    }
  }

  @Watch("selectType")
  onSelectTypeChange (newVal, oldVal) {
    if (oldVal == 1) {
      (this.$refs.dateTimePickerRef1 as any).showDatetimePicker = false
    } else if (oldVal == 2) {
      (this.$refs.dateTimePickerRef2 as any).showDatetimePicker = false
    }
    this.$emit("selectTypeChange", newVal);
  }

  showPopup () {
    this.show = true;
  }

  // 初始化日期/时间选择组件，防止拿不到dateTimePicker没有初始化完成的情况
  async executeDateTimePickerInit (
    refName: 'dateTimePickerRef1' | 'dateTimePickerRef2',
    params: {
      valueType: any;
      showDatetimePicker: boolean;
      datetimeVal1: any;
      datetimeVal2: any;
    },
    maxRetries = 10,
    interval = 50
  ) {
    const { valueType, showDatetimePicker, datetimeVal1, datetimeVal2 } = params;
    // 检查必要的值是否存在
    if (!datetimeVal1 || !datetimeVal2) {
      return;
    }

    for (let i = 0; i < maxRetries; i++) {
      const ref = this.$refs[refName] as any;

      if (ref?.initData) {
        // 找到 initData，执行并返回
        ref.initData({
          valueType,
          showDatetimePicker,
          datetimeVal1,
          datetimeVal2
        });
        return;
      }
      // 等待一段时间后重试
      await new Promise(resolve => setTimeout(resolve, interval));
    }
  }

  // 获取当前时间文本
  getNowTimeText (starttime: string, endtime: string) {
    const nowTimeText = `${timeFormat(starttime)} - ${timeFormat(endtime)}`
    return handleFill(nowTimeText)
  }

  onCancel () {
    this.show = false;
  }

  onConfirm () {
    const { datetimeVal1: startVal1, datetimeVal2: startVal2 } = (this.$refs.dateTimePickerRef1 as any).picker;
    const { datetimeVal1: endVal1, datetimeVal2: endVal2 } = (this.$refs.dateTimePickerRef2 as any).picker;
    if (!startVal1) {
      this.$toast(`请选择${this.startPlaceholder1}`)
      return false
    }
    if (!startVal2) {
      this.$toast(`请选择${this.startPlaceholder2}`)
      return false
    }
    if (!endVal1) {
      this.$toast(`请选择${this.endPlaceholder1}`)
      return false
    }
    if (!endVal2) {
      this.$toast(`请选择${this.endPlaceholder2}`)
      return false
    }
    const { formatDateTime, valueType: startDatetimeValueType, showDatetimePicker: showStartDatetimePicker } = (this.$refs.dateTimePickerRef1 as any);
    const { valueType: endDatetimeValueType, showDatetimePicker: showEndDatetimePicker } = (this.$refs.dateTimePickerRef2 as any);
    const starttime = `${formatDateTime(startVal1)} ${formatDateTime(startVal2)}`
    const endtime = `${formatDateTime(endVal1)} ${formatDateTime(endVal2)}`
    // 转换为时间戳比较时间大小
    if (dayjs(starttime).valueOf() > dayjs(endtime).valueOf()) {
      this.$toast(`${this.startPlaceholder2}不能大于${this.endPlaceholder2}`)
      return false
    }
    const res = {
      label: this.customDateText,
      value: this.selectType,
      // 回显
      startVal1,
      startVal2,
      startDatetimeValueType,
      showStartDatetimePicker,
      endVal1,
      endVal2,
      endDatetimeValueType,
      showEndDatetimePicker,
      // 传参
      starttime,
      endtime,
      // 显示
      nowTimeText: this.getNowTimeText(starttime, endtime)
    }
    this.$emit("confirm", res);
    this.show = false;
  }
}
export default SearchPopup;
